import InputsCreatorUniversal from "../../../../hooks/inputCreatorUniversal";
import innerStyles from "./universalInputComponent.module.css";

export const renderValue = (item, newData) => {
  const rawValue = newData?.[item.key];
  const value = rawValue === 0 ? 0 : rawValue || "—";

  if (item.type === "selectWithSearch") {
    const selectedOption = item.options.find((elem) =>
      typeof elem.value === "number" ? elem.value === Number(value) : elem.value === value,
    )?.label;
    return selectedOption || value || "—";
  }

  if (item.type === "date" && typeof value === "string") {
    return value.split("-").reverse().join(".");
  }

  return value;
};

export default function UniversalInputComponent({
  options,
  mode,
  styles,
  register,
  unregister,
  newData,
  control,
  setValue,
  errors,
  handleCustomButton,
  clearErrors,
  getValues,
  setError,
}) {
  return (mode === "add" || mode === "edit") && options?.blockVisibility ? (
    <div className={innerStyles["component-container"]}>
      <p className={innerStyles["component-caption"]}>{options?.caption}</p>
      <div className={`${innerStyles["inputs-container"]}`}>
        <div className={styles[options?.gridKey]}>
          {Object.values(options?.inputsOptions).map((item) =>
            item?.needInForm ? (
              item?.caption ? (
                <p
                  key={item.key}
                  className={`${innerStyles["secondary-caption"]} ${innerStyles[`box-${item.key}`]}`}>
                  {item.caption}
                </p>
              ) : item.fieldModeView ? (
                <div
                  key={item.key}
                  className={`${innerStyles["text-block"]} ${innerStyles?.[`box-${item.key}`]}`}>
                  <p className={innerStyles["option-label"]}>{item.label}</p>
                  <p className={innerStyles["option-value"]}>{renderValue(item, newData)}</p>
                </div>
              ) : (
                <InputsCreatorUniversal
                  key={item.key}
                  option={item}
                  styles={innerStyles}
                  register={register}
                  unregister={unregister}
                  newData={newData}
                  control={control}
                  setValue={setValue}
                  mode={mode}
                  errors={errors}
                  clearErrors={clearErrors}
                  handleCustomButton={handleCustomButton}
                  getValues={getValues}
                  setError={setError}
                />
              )
            ) : null,
          )}
        </div>
      </div>
    </div>
  ) : (
    options.blockVisibility && (
      <div className={innerStyles["component-container"]}>
        <p className={innerStyles["component-caption"]}>{options?.caption}</p>
        <div className={`${innerStyles["inputs-container"]}`}>
          <div className={styles[options?.gridKey]}>
            {Object.values(options?.inputsOptions).map((item) =>
              item?.needInForm ? (
                item?.caption ? (
                  <p
                    key={item.key}
                    className={`${innerStyles["secondary-caption"]} ${innerStyles[`box-${item.key}`]}`}>
                    {item.caption}
                  </p>
                ) : (
                  <div
                    key={item.key}
                    className={`${innerStyles["text-block"]} ${innerStyles?.[`box-${item.key}`]}`}>
                    <p className={innerStyles["option-label"]}>{item.label}</p>
                    <p className={innerStyles["option-value"]}>{renderValue(item, newData)}</p>
                  </div>
                )
              ) : null,
            )}
          </div>
        </div>
      </div>
    )
  );
}
